import {Col} from "antd";
import React from "react";
import InputField from "../../input-field";

export default function LegalEntityFormFields({data, setFormFieldsValues, formFieldsValues, fields, fieldsErrors}){
  if(!data) {
    return null;
  }

  const getFieldErrors = (fieldName) => {
      fieldName = fieldName.charAt(0).toLowerCase()+fieldName.slice(1);
      return (typeof fieldsErrors[fieldName] !== "undefined")
          ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
              return fieldErrors + '; ' + error;
          })
          : null;
  };
  
  return fields.map((item) => {
    return <Col span={24}>
      <InputField
        name={item.key}
        title={item.title}
        label={item.title}
        value={formFieldsValues[item.key]}
        setValue={(value) => {
          setFormFieldsValues({...formFieldsValues, [item.key]: value});
        }}
        getFieldErrors={getFieldErrors}
      />
    </Col>
  });
}
